module.exports = __webpack_public_path__ + "img/sport.b26cdc35.png";